import {
  createUploadUrl,
  uploadFileToPresignedUrl,
  type CreateUploadUrlRequest,
} from "@/features/documents/api/documents.api"

export interface UploadDocumentInput {
  file: File
  title?: string
  description?: string
  level: CreateUploadUrlRequest["level"]
  contractId?: string
  orderId?: string
  deliveryId?: string
  batchId?: string
  lotId?: string
  logId?: string
}

function safeFileKey(name: string): string {
  const lastDot = name.lastIndexOf(".")
  const base = lastDot >= 0 ? name.slice(0, lastDot) : name
  const ext = lastDot >= 0 ? name.slice(lastDot + 1) : ""
  const slug = base
    .normalize("NFKD")
    .replace(/[^\w\s-]+/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .toLowerCase()
    .slice(0, 80)
  const stamp = Date.now()
  const random = Math.random().toString(36).slice(2, 8)
  return ext ? `${slug || "file"}-${stamp}-${random}.${ext}` : `${slug || "file"}-${stamp}-${random}`
}

export async function uploadDocument(input: UploadDocumentInput): Promise<{
  storedKey: string
}> {
  const documentKey = safeFileKey(input.file.name)
  const extension = documentKey.includes(".")
    ? (documentKey.split(".").pop() ?? "")
    : ""

  const presigned = await createUploadUrl({
    level: input.level,
    documentKey,
    documentExtension: extension,
    title: input.title,
    description: input.description,
    contractId: input.contractId,
    orderId: input.orderId,
    deliveryId: input.deliveryId,
    batchId: input.batchId,
    lotId: input.lotId,
    logId: input.logId,
  })

  await uploadFileToPresignedUrl(presigned.url, input.file)
  return { storedKey: presigned.storedKey }
}
